export const CUSTOMER_GROUP_ID = 'customer_group_id';
export const IS_REUNION = 'is_reunion';
export const LANGUAGE = 'language';
export const STORE_ID = 'storeID';
export const QUOTE_ID = 'quoteid';
export const CART_ITEMS_DATA_COUNT = 'cartItemsdataCount';
export const USER = 'user';
export const RECENTLY_VIEWED_DEALS = 'recent';
export const MARIDEAL_PWA_USER = 'marideal-pwa_user';
